import { Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../../../common/models';

export class AllocationViewUliDriverSignatureModel {
  public driverSignatureSkipped: boolean;
  public updateDataSignature: string;
  public storeFrequentDriver = false;

  constructor(params?: AllocationViewUliDriverSignatureModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewUliDriverSignatureForm {
  constructor(
    model: AllocationViewUliDriverSignatureModel,
    public driverSignatureSkipped: boolean = model.driverSignatureSkipped,
    public updateDataSignature: ControlProperty<string> = [model.updateDataSignature, Validators.required],
    public storeFrequentDriver: ControlProperty<boolean> = model.storeFrequentDriver || false,
  ) {}
}
